import { wencesApi } from '@/api/wencesApi';

class ChatService {
  // Get all conversations
  async getConversations() {
    const response = await wencesApi.get('/api/chat/conversations');
    return response.data;
  }

  // Get messages between current user and another user
  async getMessages(userId, limit = 50, before = null) {
    const params = { limit };
    if (before) {
      params.before = before;
    }
    const response = await wencesApi.get(`/api/chat/messages/${userId}`, { params });
    return response.data;
  }

  // Send a message
  async sendMessage(recipient, message, messageType = 'text', attachments = []) {
    const response = await wencesApi.post('/api/chat/send', {
      recipient,
      message,
      messageType,
      attachments
    });
    return response.data;
  }

  // Mark messages as read
  async markAsRead(userId) {
    const response = await wencesApi.post(`/api/chat/read/${userId}`);
    return response.data;
  }

  // Get unread message count
  async getUnreadCount() {
    const response = await wencesApi.get('/api/chat/unread-count');
    return response.data;
  }

  // Get online users
  async getOnlineUsers() {
    const response = await wencesApi.get('/api/chat/online-users');
    return response.data;
  }

  // Delete a message
  async deleteMessage(messageId) {
    const response = await wencesApi.delete(`/api/chat/message/${messageId}`);
    return response.data;
  }

  // Get all users (for selecting who to chat with)
  async getAllUsers() {
    const response = await wencesApi.get('/api/users/all');
    return response.data;
  }
}

export default new ChatService();

